/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo200,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo401,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo404,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo500,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfoPathParams,
  GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfoQueryResponse,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo.ts";

export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfoPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
    cultureInfo: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo200Schema =
  z.instanceof(
    File,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo500>;

export const getApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfoQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfo200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidCourseManualCultureinfoQueryResponse>;
